<template>
  <div class="recruiting-dashboard">
    <div v-if="hasManagerRole" class="row mb-4">
      <div class="col">
        <a-job-application-process-dashlet
          v-if="dashboard.jobApplicationStatesWithCount"
          :data="dashboard.jobApplicationStatesWithCount"
        />
      </div>
    </div>
    <div class="atom-dashboard">
      <div class="row">
        <div v-if="hasManagerRole" :class="getDashletColClasses()">
          <a-open-tasks-dashlet
            v-if="dashboard.openTasks"
            :data="dashboard.openTasks"
          />
        </div>
        <div v-if="hasManagerRole" :class="getDashletColClasses()">
          <a-new-job-applications-dashlet
            v-if="dashboard.newJobApplications"
            :data="dashboard.newJobApplications"
          />
        </div>
        <div v-if="hasManagerRole" :class="getDashletColClasses()">
          <a-job-postings-dashlet
            v-if="dashboard.publishedJobPostings"
            :data="dashboard.publishedJobPostings"
          />
        </div>
        <div v-if="hasLeaderRole" :class="getDashletColClasses()">
          <a-file-circulation-dashlet
            v-if="dashboard.fileCirculationsToRate"
            :data="dashboard.fileCirculationsToRate"
          />
        </div>
        <div v-if="hasLeaderRole" :class="getDashletColClasses()">
          <a-job-interviews-dashlet
            v-if="dashboard.jobInterviews"
            :data="dashboard.jobInterviews"
          />
        </div>
        <div v-if="hasLeaderRole" :class="getDashletColClasses()">
          <a-open-job-interview-decisions-dashlet
            v-if="dashboard.openJobInterviewDecisions"
            :data="dashboard.openJobInterviewDecisions"
          />
        </div>
        <div v-if="hasLeaderRole" :class="getDashletColClasses()">
          <a-open-job-postings-dashlet
            v-if="dashboard.openJobPostings"
            :data="dashboard.openJobPostings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//SB
import OpenTasksDashlet from "~/recruiting-system/components/dashboard/OpenTasksDashlet.vue";
import NewJobApplicationsDashlet from "~/recruiting-system/components/dashboard/NewJobApplicationsDashlet.vue";
import JobPostingsDashlet from "~/recruiting-system/components/dashboard/JobPostingsDashlet.vue";
import JobApplicationProcessDashlet from "~/recruiting-system/components/dashboard/JobApplicationProcessDashlet.vue";
//FK
import JobInterveiwsDashlet from "~/recruiting-system/components/dashboard/JobInterviewsDashlet.vue";
import OpenJobInterviewDecisionsDashlet from "~/recruiting-system/components/dashboard/OpenJobInterviewDecisionsDashlet.vue";
import FileCirculationsDashlet from "~/recruiting-system/components/dashboard/FileCirculationsDashlet.vue";
import OpenJobPostingsDashlet from "~/recruiting-system/components/dashboard/OpenJobPostingsDashlet.vue";

import RecruitingRole from "./graphql/RecruitingRole.gql";
import DashboardQuery from "./graphql/DashboardQuery.gql";
import { redirectIfNoAccess } from "@/config/router.js";

import apolloProvider from "@/apollo/provider.js";

export default {
  components: {
    "a-open-tasks-dashlet": OpenTasksDashlet,
    "a-new-job-applications-dashlet": NewJobApplicationsDashlet,
    "a-job-postings-dashlet": JobPostingsDashlet,
    "a-job-application-process-dashlet": JobApplicationProcessDashlet,
    "a-job-interviews-dashlet": JobInterveiwsDashlet,
    "a-file-circulation-dashlet": FileCirculationsDashlet,
    "a-open-job-postings-dashlet": OpenJobPostingsDashlet,
    "a-open-job-interview-decisions-dashlet": OpenJobInterviewDecisionsDashlet
  },
  data() {
    return {
      dashboard: {},
      hasLeaderRole: false,
      hasManagerRole: false
    };
  },
  methods: {
    getDashletColClasses: () => "col-sm-12 col-lg-6 col-xl-4 mb-4"
  },
  beforeRouteEnter(to, from, next) {
    apolloProvider.clients.recruiting
      .query({
        query: RecruitingRole
      })
      .then(
        ({ data: { hasRecruitingLeaderRole, hasRecruitingManagerRole } }) => {
          redirectIfNoAccess(
            hasRecruitingLeaderRole || hasRecruitingManagerRole,
            next,
            (vm) => {
              vm.hasLeaderRole = hasRecruitingLeaderRole;
              vm.hasManagerRole = hasRecruitingManagerRole;
            }
          );
        }
      );
  },
  apollo: {
    $client: "recruiting",
    dashboard: {
      query: DashboardQuery,
      update: (data) => data
    }
  }
};
</script>
